/* ==========================================================================
   PN 2.43 — 31.08.2026
   Koleksiyon ici hizli arama — istemci tarafi filtreleme.

   Yalnizca gorunurlugu degistirir; hicbir baglanti DOM'dan cikarilmaz.
   Arama kutusu bosaltilinca liste eski haline doner.

   Turkce arama notu: "İ/ı" ve "I/i" ciftleri yuzunden duz toLowerCase()
   yaniltici olabiliyor. Once Turkce'ye ozgu harfler sadelestirilir, sonra
   karsilastirilir — boylece "yag" yazan "yağ"i, "ucucu" yazan "uçucu"yu
   buluyor.
   ========================================================================== */
(function () {
  'use strict';

  var MAP = {
    ç: 'c', Ç: 'c',
    ğ: 'g', Ğ: 'g',
    ı: 'i', I: 'i', İ: 'i', i: 'i',
    ö: 'o', Ö: 'o',
    ş: 's', Ş: 's',
    ü: 'u', Ü: 'u'
  };

  function fold(str) {
    var out = '';
    for (var i = 0; i < str.length; i++) {
      var ch = str[i];
      out += MAP[ch] !== undefined ? MAP[ch] : ch.toLowerCase();
    }
    return out;
  }

  function initOne(root) {
    if (root.dataset.pnIndexBound) return;
    root.dataset.pnIndexBound = '1';

    var input = root.querySelector('[data-pn-index-input]');
    var list = root.querySelector('[data-pn-index-list]');
    var empty = root.querySelector('[data-pn-index-empty]');
    if (!input || !list) return;

    var items = Array.prototype.slice.call(list.children);
    var keys = items.map(function (li) {
      return fold(li.textContent || '');
    });

    var timer = null;

    function apply() {
      var q = fold(input.value.trim());
      var shown = 0;

      for (var i = 0; i < items.length; i++) {
        var match = q === '' || keys[i].indexOf(q) !== -1;
        items[i].hidden = !match;
        if (match) shown++;
      }

      if (empty) empty.hidden = shown !== 0;
    }

    input.addEventListener('input', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(apply, 90);
    });

    // Arama kutusundaki temizle (x) dugmesi ve Escape
    input.addEventListener('search', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        input.value = '';
        apply();
      }
    });

    // Acilinca odagi kutuya ver — kullanici zaten aramak icin acti.
    var details = root;
    details.addEventListener('toggle', function () {
      if (details.open) {
        try {
          input.focus({ preventScroll: true });
        } catch (err) {
          input.focus();
        }
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-pn-index]');
    Array.prototype.forEach.call(roots, initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
